<template>
    <div class="agent-page">
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">中标候选人公示</h2>
            </div>
            <div style="display: flex; gap: 12px;">
                <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加中标候选人公示</el-button>
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
                
            </div>
        </div>
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="winCandidateBulletinCode" label="候选人公示编号" show-overflow-tooltip />
                <el-table-column prop="winCandidateBulletinName" label="候选人公示标题" show-overflow-tooltip />
                <el-table-column prop="startTime" label="开始时间" show-overflow-tooltip />
                <el-table-column prop="endTime" label="结束时间" show-overflow-tooltip />
                <el-table-column prop="status" label="状态" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag size="small">
                            {{ getStatusType(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="typeCode" label="公示类型" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag size="small">
                            {{ getTypeCode(scope.row.typeCode) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <template v-if="scope.row.status === '0' || scope.row.status === '2' || scope.row.status === 0 || scope.row.status === 2">
                            <el-button type="text" size="small" @click="handleEdit(scope.row)" class="action-btn">
                                编辑
                            </el-button>
                            <el-button type="text" size="small" @click="handleViewDelete(scope.row)" class="action-btn" style="color: #f56c6c;">
                                删除
                            </el-button>
                        </template>
                        <template v-else>
                            <el-button type="text" size="small" @click="handleViewDetails(scope.row)" class="action-btn">
                                查看详情
                            </el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 添加中标候选人公示弹窗 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="80%" :before-close="handleClose"
            :append-to-body="true" :close-on-click-modal="false">
            <div class="dialog-content">
                <el-form ref="candidateForm" :model="formData" :rules="formRules" label-width="180px"
                    class="candidate-form">

                    <!-- 标段选择 -->
                    <el-form-item label="标段名称:" prop="bidSectionCode" required>
                        <el-select v-model="formData.bidSectionCode" placeholder="请选择标段" style="width: 100%"
                            @change="handleSectionChange" :disabled="!isEditable" >
                            <el-option v-for="item in bidSectionList" :key="item.bidSectionCode"
                                :label="item.bidSectionName" :value="item.bidSectionCode">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <!-- 候选人公示标题 -->
                    <el-form-item label="候选人公示标题:" prop="winCandidateBulletinName" required>
                        <el-input v-model="formData.winCandidateBulletinName" placeholder="请输入候选人公示标题"
                            style="width: 100%" :disabled="!isEditable" >
                        </el-input>
                    </el-form-item>

                    <!-- 公示类型 -->
                    <el-form-item label="公示类型:" prop="typeCode" required>
                        <el-radio-group v-model="formData.typeCode" :disabled="!isEditable">
                            <el-radio :label="1">正常公示</el-radio>
                            <el-radio :label="2">更正</el-radio>
                            <!-- <el-radio :label="9">其他</el-radio> -->
                        </el-radio-group>
                    </el-form-item>

                    <!-- 发布时间 -->
                    <el-form-item label="发布时间:" prop="publicTime" required>
                        <app-date-picker v-model="formData.publicTime" type="datetime" placeholder="选择发布时间"
                            style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" @change="handlePublicTimeChange" :disabled="!isEditable">
                        </app-date-picker>
                    </el-form-item>

                    <!-- 结束时间 -->
                    <el-form-item label="结束时间:" prop="endTime" required>
                        <app-date-picker v-model="formData.endTime" type="datetime" placeholder="选择结束时间"
                            style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" :disabled="!isEditable">
                        </app-date-picker>
                    </el-form-item>

                    <!-- 代理项目经理 -->
                    <!-- <el-form-item label="代理项目经理:" prop="agencyManager">
                        <el-input v-model="formData.agencyManager" placeholder="请输入代理项目经理姓名" style="width: 100%" :disabled="status==1">
                        </el-input>
                    </el-form-item> -->

                    <!-- 代理项目经理资质 -->
                    <!-- <el-form-item label="代理项目经理资质:" prop="agencyManagerCertification">
                        <el-input v-model="formData.agencyManagerCertification" placeholder="请输入代理项目经理资质"
                            style="width: 100%" :disabled="status==1">
                        </el-input>
                    </el-form-item> -->

                    <!-- 代理项目经理身份证 -->
                    <!-- <el-form-item label="代理项目经理身份证:" prop="agencyManagerId">
                        <el-input v-model="formData.agencyManagerId" placeholder="请输入代理项目经理身份证号" style="width: 100%"
                            maxlength="18" :disabled="status==1">
                        </el-input>
                    </el-form-item> -->

                    <!-- 全部投标人 -->
                    <!-- <el-form-item label="全部投标人:" prop="allBidders">
                        <el-input v-model="formData.allBidders" type="textarea" :rows="3" placeholder="请输入全部投标人信息"
                            style="width: 100%" :disabled="status==1">
                        </el-input>
                    </el-form-item> -->

                    <!-- 否决投标人及理由 -->
                    <!-- <el-form-item label="否决投标人及理由:" prop="vetoBidderReason">
                        <el-input v-model="formData.vetoBidderReason" type="textarea" :rows="3"
                            placeholder="请输入否决投标人及理由" style="width: 100%" :disabled="status==1">
                        </el-input>
                    </el-form-item> -->

                    <!-- 异议渠道或方式 -->
                    <!-- <el-form-item label="异议渠道或方式:" prop="complaints">
                        <el-input v-model="formData.complaints" type="textarea" :rows="2" placeholder="请输入异议渠道或方式"
                            style="width: 100%" :disabled="status==1">
                        </el-input>
                    </el-form-item> -->

                    <!-- 候选人公示内容 -->
                    <el-form-item label="候选人公示内容:" prop="winCandidateBulletinContent" required>
                        <el-button @click="winCandidateBulletinCreateContent" type="success"
                            style="margin-bottom: 5px;" :disabled="!isEditable">
                            生成
                        </el-button>
                        <RichTextEditor v-model="formData.winCandidateBulletinContent" :height="400"
                            placeholder="请输入候选人公示内容..." toolbar-type="default" :disabled="!isEditable" />
                    </el-form-item>

                    <!-- 附件 -->
                    <el-form-item label="附件:" prop="attachments">
                        <div class="attachment-section">
                            <div class="upload-area" v-if="isEditable">
                                <el-button type="primary" @click="selectFile" :loading="uploading"
                                    v-if="formData.uploadedFiles.length == 0" >
                                    {{ uploading ? '上传中...' : '选取文件' }}
                                </el-button>
                                <input ref="fileInput" type="file" style="display: none" @change="handleFileSelect"
                                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.zip,.rar">
                            </div>

                            <div class="file-table" v-if="formData.uploadedFiles.length > 0">
                                <el-table :data="formData.uploadedFiles" style="width: 100%">
                                    <el-table-column prop="fileName" label="文件名"></el-table-column>
                                    <el-table-column prop="uploadTime" label="上传时间"></el-table-column>
                                    <el-table-column prop="uploadProgress" label="上传进度" width="120">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.uploadProgress !== undefined">
                                                {{ scope.row.uploadProgress }}%
                                            </span>
                                            <span v-else>已完成</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="150">
                                        <template slot-scope="scope">
                                            <el-button type="text" size="small" @click="handleFileDownload(scope.row)">
                                                下载
                                            </el-button>
                                            <el-button v-if="isEditable" type="text" size="small" @click="removeFile(scope.$index, scope.row)" style="color: #f56c6c;">
                                                删除
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">{{ isEditable ? '取 消' : '关 闭' }}</el-button>
                <el-button type="primary" @click="handleSaveTemp" :loading="saving" v-if="isEditable">暂 存</el-button>
                <el-button type="success" @click="handleSubmit" :loading="submitting" v-if="isEditable">提 交</el-button>
            </span>
        </el-dialog>
    </div>

</template>

<script>
import { loadProjectDetail } from '@/utils/bid/projectInfo'
import { winCandidateBulletinInit, winCandidateBulletinAdd, winCandidateBulletinDetail, winCandidateBulletinDelete, winCandidateBulletinOtherInfo, winCandidateBulletinCreateContent, winCandidateBulletinList } from '@/api/modules/winCandidateBulletin'
import { doFileUpload } from '@/utils/upload/fileUploadHelper'
import RichTextEditor from '@/components/common/RichTextEditor.vue'
import { getFileList } from '@/api/modules/base'
import { deleteBidAtt } from '@/api/modules/make'

export default {
    components: {
        RichTextEditor
    },
    data() {
        // 身份证号验证
        const validateIdCard = (rule, value, callback) => {
            if (!value) {
                callback()
                return
            }
            const idCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
            if (!idCardReg.test(value)) {
                callback(new Error('请输入正确的身份证号码'))
            } else {
                callback()
            }
        }

        return {
            // 页面基础信息
            projectTitle: '',
            projectCode: this.$route.query.projectCode,
            dialogVisible: false,
            loading: false,
            uploading: false,
            saving: false,
            submitting: false,
            publishing: false,
            tableData: [],
            // 标段列表
            bidSectionList: [],
            status:0,
            // 表单数据
            formData: {
                projectCode: this.$route.query.projectCode || '',
                bidSectionCode: '',
                bidSectionName: '',
                winCandidateBulletinName: '',
                winCandidateBulletinContent: '',
                typeCode: 1,
                publicTime: '',
                startTime: '',
                endTime: '',
                agencyManager: '',
                agencyManagerCertification: '',
                agencyManagerId: '',
                allBidders: '',
                vetoBidderReason: '',
                complaints: '',
                fileGuid: '',
                uploadedFiles: [],
                status: 0
            },
            // 表单验证规则
            formRules: {
                bidSectionCode: [
                    { required: true, message: '请选择标段' }
                ],
                winCandidateBulletinName: [
                    { required: true, message: '请输入候选人公示标题' }
                ],
                typeCode: [
                    { required: true, message: '请选择公示类型'}
                ],
                publicTime: [
                    { required: true, message: '请选择发布时间' }
                ],
                endTime: [
                    { required: true, message: '请选择结束时间' }
                ],
                winCandidateBulletinContent: [
                    { required: true, message: '请输入候选人公示内容' }
                ],
                agencyManagerId: [
                    { validator: validateIdCard, trigger: 'blur' }
                ]
            }
        }
    },
    computed: {
        isEditable() {
            return this.status == 0 || this.status == 2
        },
        dialogTitle() {
            if (this.isEditable && this.formData.bidSectionCode) return '编辑中标候选人公示'
            if (this.isEditable) return '新增中标候选人公示'
            return '查看中标候选人公示'
        }
    },
    mounted() {
        this.initPage()
    },
    methods: {
        // 初始化页面
        initPage() {
            this.getProjectInfo()
            this.winCandidateBulletinInit()
            this.winCandidateBulletinList()
        },
        //返回上一个页面
        handleBack() {
            this.$router.go(-1)
        },
        //列表
        async winCandidateBulletinList() {
            try {
                const res = await winCandidateBulletinList({
                    projectCode: this.projectCode,
                    pageNum: 1,
                    pageSize: 10,

                })
                if (res.code === 200) {
                    this.tableData = res.data.records
                } else {
                    this.$message.error(res.msg)
                }
            } catch (error) {
                console.error('初始化失败:', error)
                this.$message.error('网络异常')
            }

        },
        // 关闭弹窗
        handleClose() {
            this.dialogVisible = false
            this.resetForm()
        },
        // 查看详情（只读）
        handleViewDetails(row) {
            this.status = row.status
            this.winCandidateBulletinDetail(row.winCandidateBulletinCode)
        },
        // 编辑（暂存/退回状态）
        handleEdit(row) {
            this.status = row.status
            this.winCandidateBulletinDetail(row.winCandidateBulletinCode)
        },
        //  查看详情 接口
        async winCandidateBulletinDetail(winCandidateBulletinCode) {
            try {
                const res = await winCandidateBulletinDetail(winCandidateBulletinCode)
                if (res.code === 200) {
                    console.log(res.data);
                    this.formData = {
                        ...res.data,
                        uploadedFiles: res.data.uploadedFiles || []
                    }
                    this.dialogVisible = true
                    this.getFileList(res.data.fileGuid)

                } else {
                    this.$message.error(res.msg)
                }
            } catch (error) {
                console.error('初始化失败:', error)
                this.$message.error('网络异常')
            }

        },
        //获取文件
       async getFileList(fileGuid){
             try {
                const res = await getFileList(fileGuid)
                if (res.code === 200 && res.data) {
                      this.formData.uploadedFiles = res.data
                } else {
                    this.downloadDialogVisible = false
                }
            } catch (error) {
                console.error('获取文件下载列表失败:', error)
                this.$message.error('获取文件下载列表失败，请重试')
                this.downloadDialogVisible = false
            } finally {}

        },
        // 删除
        handleViewDelete(row) {
            this.$confirm('确定要删除当前公示吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.winCandidateBulletinDelete(row.winCandidateBulletinCode)
            }).catch(() => {
            })
        },
        // 删除接口
        async winCandidateBulletinDelete(winCandidateBulletinCode) {
            try {
                const res = await winCandidateBulletinDelete({
                    winCandidateBulletinCode:winCandidateBulletinCode
                })
                if (res.code === 200) {
                    this.initPage()
                } else {
                    this.$message.error(res.msg)
                }
            } catch (error) {
                this.$message.error('网络异常')
            }
        },
        //  添加
        handleAdd() {
            this.status = 0;
            this.dialogVisible = true
            this.resetForm()
            this.formData.fileGuid = new Date().getTime() + Math.random().toString().substr(2, 5)
        },
        // 重置表单
        resetForm() {
            this.formData = {
                projectCode: this.$route.query.projectCode || '',
                bidSectionCode: '',
                bidSectionName: '',
                winCandidateBulletinName: '',
                winCandidateBulletinContent: '',
                typeCode: 1,
                publicTime: '',
                startTime: '',
                endTime: '',
                agencyManager: '',
                agencyManagerCertification: '',
                agencyManagerId: '',
                allBidders: '',
                vetoBidderReason: '',
                complaints: '',
                fileGuid: '',
                uploadedFiles: [],
                status: 0
            }
            if (this.$refs.candidateForm) {
                this.$refs.candidateForm.clearValidate()
            }
        },

        // 初始化标段列表
        async winCandidateBulletinInit() {
            try {
                const res = await winCandidateBulletinInit(this.projectCode)
                if (res.code === 200) {
                    console.log('初始化数据:', JSON.stringify(res.data))
                    this.bidSectionList = res.data.bidSectionList || []
                } else {
                    this.$message.error(res.msg)
                }
            } catch (error) {
                console.error('初始化失败:', error)
                this.$message.error('网络异常')
            }
        },
        //  获取标题
        async getProjectInfo() {
            this.projectTitle = await loadProjectDetail(this.projectCode)
        },
        // 标段选择变化
        handleSectionChange(bidSectionCode) {
            const selectedSection = this.bidSectionList.find(item => item.bidSectionCode === bidSectionCode)
            if (selectedSection) {
                this.formData.bidSectionName = selectedSection.bidSectionName
                this.formData.winCandidateBulletinName = selectedSection.bidSectionName + '（中标候选人公示）'
            }
            this.winCandidateBulletinOtherInfo(bidSectionCode)
        },
        //获取标段其他信息
        async winCandidateBulletinOtherInfo(bidSectionCode) {
            try {
                const res = await winCandidateBulletinOtherInfo({
                    bidSectionCode: bidSectionCode,
                    stage: 0
                })
                if (res.code === 200) {
                    this.formData.allBidders = res.data.allBidders;

                } else {
                    this.$message.error(res.msg)
                }
            } catch (error) {
                console.error('初始化失败:', error)
                this.$message.error('网络异常')
            }

        },
        //生成候选人公式内容
        async winCandidateBulletinCreateContent() {
            if (this.formData.bidSectionName == '' || this.formData.bidSectionName.length == 0 || this.formData.bidSectionName == null) {
                this.$message.error("请选择标段")
                return;
            }
            try {
                const res = await winCandidateBulletinCreateContent(this.formData)
                if (res.code === 200) {
                    this.formData.winCandidateBulletinContent = res.data
                } else {
                    this.$message.error(res.msg)
                }
            } catch (error) {
                console.error('初始化失败:', error)
                this.$message.error('网络异常')
            }

        },
        // 发布时间变化
        handlePublicTimeChange(value) {
            // 开始时间和发布时间一致
            this.formData.startTime = value
        },
        // 选择文件
        selectFile() {
            if (this.uploading) {
                this.$message.warning('请等待当前文件上传完成')
                return
            }
            this.$refs.fileInput.click()
        },
        // 处理文件选择
        async handleFileSelect(event) {
            const file = event.target.files[0]
            if (!file) return

            // 检查文件类型
            const allowedTypes = ['.jpg', '.jpeg', '.png', '.pdf', '.doc', '.docx', '.zip', '.rar']
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase()

            if (!allowedTypes.includes(fileExtension)) {
                this.$message.error('文件类型不支持，请选择 jpg, png, pdf, doc, docx, zip, rar 格式的文件')
                event.target.value = ''
                return
            }

            // 检查文件大小 (限制为100MB)
            const maxSize = 100 * 1024 * 1024
            if (file.size > maxSize) {
                this.$message.error('文件大小不能超过100MB')
                event.target.value = ''
                return
            }

            // 添加到文件列表（先显示上传中状态）
            const fileInfo = {
                fileName: file.name,
                uploadTime: this.formatDateTime(new Date()),
                uploadProgress: 0,
                file: file
            }
            this.formData.uploadedFiles.push(fileInfo)
            const fileIndex = this.formData.uploadedFiles.length - 1

            // 开始上传
            this.uploading = true
            try {
                const result = await doFileUpload(file, {
                    fileBindId: this.formData.fileGuid,
                    onProgress: (percentage) => {
                        this.$set(this.formData.uploadedFiles[fileIndex], 'uploadProgress', Math.floor(percentage))
                    },
                    onSuccess: (uploadResult) => {
                        // 上传成功，更新文件信息
                        this.$set(this.formData.uploadedFiles[fileIndex], 'fileGuid', uploadResult.fileGuid)
                        this.$set(this.formData.uploadedFiles[fileIndex], 'uploadFileId', uploadResult.uploadFileId)
                        this.$set(this.formData.uploadedFiles[fileIndex], 'filePath', uploadResult.filePath)
                        this.$set(this.formData.uploadedFiles[fileIndex], 'uploadProgress', undefined)
                        this.$message.success('文件上传成功')
                    },
                    onError: (error) => {
                        console.error('文件上传失败:', error)
                        this.$message.error(error.message || '文件上传失败')
                        // 上传失败，从列表中移除
                        this.formData.uploadedFiles.splice(fileIndex, 1)
                    }
                })

                if (!result.success) {
                    throw new Error(result.message || '上传失败')
                }
            } catch (error) {
                console.error('文件上传异常:', error)
                // 确保失败的文件被移除
                const currentFile = this.formData.uploadedFiles[fileIndex]
                if (currentFile && currentFile.uploadProgress !== undefined) {
                    this.formData.uploadedFiles.splice(fileIndex, 1)
                }
            } finally {
                this.uploading = false
                // 清空input
                event.target.value = ''
            }
        },
        // 下载文件
        handleFileDownload(row) {
            const fileUrl = row.fileUrl || row.filePath
            if (!fileUrl) {
                this.$message.warning('文件下载地址不存在')
                return
            }
            const link = document.createElement('a')
            link.href = fileUrl
            link.download = row.fileName || '附件'
            link.target = '_blank'
            link.rel = 'noopener'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
        // 删除文件
        removeFile(index, row) {
            this.$confirm('确定要删除该文件吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                if (row && row.fileId) {
                    try {
                        const res = await deleteBidAtt(row.fileId)
                        if (res.code === 200) {
                            this.formData.uploadedFiles.splice(index, 1)
                            this.$message.success('文件删除成功')
                        } else {
                            this.$message.error(res.msg || '删除失败')
                        }
                    } catch (error) {
                        console.error('删除文件失败:', error)
                        this.$message.error('删除文件失败')
                    }
                } else {
                    this.formData.uploadedFiles.splice(index, 1)
                    this.$message.success('文件删除成功')
                }
            }).catch(() => { })
        },
        // 格式化日期时间
        formatDateTime(date) {
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        },
        // 暂存
        handleSaveTemp() {
            this.formData.status = 0
            this.submitForm('saving')
        },
        // 提交
        handleSubmit() {
            this.formData.status = 1
            this.submitForm('submitting')
        },
        // 提交表单
        submitForm(loadingType) {
            this.$refs.candidateForm.validate((valid) => {
                if (!valid) {
                    this.$message.error('请检查表单填写是否完整')
                    return false
                }

                // 检查是否有文件正在上传
                const uploadingFile = this.formData.uploadedFiles.find(file => file.uploadProgress !== undefined && file.uploadProgress < 100)
                if (uploadingFile) {
                    this.$message.warning('请等待文件上传完成')
                    return false
                }

                this.saveData(loadingType)
            })
        },
        // 保存数据
        async saveData(loadingType) {
            this[loadingType] = true
            try {
                const submitData = { ...this.formData }
                delete submitData.uploadedFiles

                const res = await winCandidateBulletinAdd(submitData)
                if (res.code === 200) {
                    const statusText = this.formData.status === 0 ? '暂存' : this.formData.status === 1 ? '提交' : '发布'
                    this.$message.success(`${statusText}成功！`)
                    this.dialogVisible = false
                    this.resetForm()
                    // 刷新列表
                    this.initPage()
                } else {
                    this.$message.error(res.msg || '操作失败')
                }
            } catch (error) {
                console.error('保存失败:', error)
                this.$message.error('操作失败，请重试')
            } finally {
                this[loadingType] = false
            }
        },
        // 0：暂存、1：提交、9：发布 2:退回
        getStatusType(status) {
            const statusMap = {
                '0': '暂存',
                '1': '提交',
                '2': '退回',
                '9': '发布',
            }
            return statusMap[status]
        },
        //公示类型（1：正常公示，2：更正，9：其他）
        getTypeCode(typeCode) {
            const statusMap = {
                '1': '正常公示',
                '2': '更正',
                '9': '其他',
            }
            return statusMap[typeCode]
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        // position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            // position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;
        &:hover { transform: translateY(-1px); }
    }
}

// 弹窗样式
.win-candidate-dialog {
    /deep/ .el-dialog {
        border-radius: 8px;

        .el-dialog__footer {
            padding: 20px 30px;
            border-top: 1px solid #e8e8e8;
            text-align: center;
        }
    }
}

.dialog-content {
    
    .candidate-form {
        text-align: start;

        .el-form-item {
            margin-bottom: 24px;

            .el-form-item__label {
                font-weight: 500;
                color: #333;
                line-height: 32px;
            }

            .el-form-item__content {
                line-height: 32px;
            }

            &.is-required .el-form-item__label::before {
                content: '*';
                color: #f56c6c;
                margin-right: 4px;
            }
        }

        // 附件区域样式
        .attachment-section {
            .upload-area {
                margin-bottom: 20px;
                text-align: start;

                .el-button {
                    background: #409eff;
                    border-color: #409eff;

                    &:hover {
                        background: #66b1ff;
                        border-color: #66b1ff;
                    }
                }
            }

            .file-table {
                width: 100%;

                .el-table {
                    border: 1px solid #ebeef5;
                    border-radius: 4px;
                }
            }
        }
    }
}

.dialog-footer {
    display: flex;
    justify-content: center;
    gap: 15px;

    .el-button {
        min-width: 100px;
        height: 40px;
        border-radius: 4px;
        font-size: 14px;
    }
}
</style>
